import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LOGIN_ROUTE } from './login-routing.module';
import { LoginRoutingModule } from './login-routing.module';
// import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    RouterModule.forRoot(LOGIN_ROUTE, { useHash: true })
  ],
  // declarations: [LoginComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts